import { useMutation } from '@tanstack/react-query';

import { TContractState } from '../models/shipment';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

const updateShipmentContractState =
  ({ makeRequest }: { makeRequest: any }) =>
  async (values: {
    shipmentId: string;
    contractState: TContractState;
    thingName?: string;
  }): Promise<{ success: boolean; error?: any }> => {
    const body = {
      contractState: values.contractState,
      ...(values.thingName ? { thingName: values.thingName } : {}),
    };

    const { error } = await makeRequest({
      path: `/shipments/${values.shipmentId}/contract-state`,
      method: 'patch',
      body,
    });

    // 204 No Content is a valid success response for PATCH
    // Only check for error, not for missing data
    if (error) {
      return { success: false, error };
    }

    return { success: true };
  };

type UseUpdateShipmentContractStateOptions = {
  config?: MutationConfig<ReturnType<typeof updateShipmentContractState>>;
};

export const useUpdateShipmentContractState = ({
  config,
}: UseUpdateShipmentContractStateOptions = {}) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipment');

  return useMutation({
    ...config,
    mutationFn: updateShipmentContractState({ makeRequest }),
  });
};
